import { YhBox } from "@/erp_subpackage/components/YhBox";
import { Description } from "@/erp_subpackage/components/YhBox/Description";
import React from "react";
import { useTranslation } from 'react-i18next';
import { useInternalDetailsModel } from "./internalDetailsModel";

export const TopButs = ({ id, mode }) => {
    const { t } = useTranslation();
    const { editFormVal: { code, status } } = useInternalDetailsModel();
    const internalStatusOption = [
        { label: t(`account.detail.TopButs.待申请`), value: 0 },
        { label: t(`account.detail.TopButs.待对方确认`), value: 1 },
        { label: t(`account.detail.TopButs.对方不认可`), value: 2 },
        { label: t(`account.detail.TopButs.待财务确认`), value: 3 },
        { label: t(`account.detail.TopButs.对方已驳回`), value: 4 },
        { label: t(`account.detail.TopButs.待财务审核`), value: 5 },
        { label: t(`account.detail.TopButs.财务已驳回`), value: 6 },
        { label: t(`account.detail.TopButs.待最终审核`), value: 7 },
        { label: t(`account.detail.TopButs.最终审核通过`), value: 8 },
        { label: t(`account.detail.TopButs.最终已驳回`), value: 9 },
    ]
    const orderStatu = [
        {
            label: t(`account.detail.TopButs.内部对账单号`),
            value: code ?? "",
            color: 'blue',
            status: true
        },
        {
            label: t(`account.detail.TopButs.状态`),
            value: internalStatusOption.find(item => item.value === status)?.label ?? "",
            color: 'green',
            status: true
        },
    ]

    return (
        <YhBox title={<>
            {orderStatu.map((item, index) => <Description key={index} {...item} />)}
        </>}
            hidden={mode === "edit" ? false : true}
            style={{ paddingBottom: 0, marginBottom: "15px" }}
        />
    )
}